<template>
  <div>
    <div class="right-title">
      <span>简历发布审核</span>
    </div>
    <div class="content-box">
      <div class="search-box">
        <el-input
          class="search"
          type="text"
          placeholder="请输入编号/姓名"
          v-model="search"
        >
        </el-input>
        <el-button class="btn2" @click="keyWord" type="primary">搜索</el-button>
      </div>
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',
    color: '#000;'}"
        >
          <el-table-column
            prop="id"
            label="编号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="user_real_name"
            label="姓名"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="caozuo"
            label="审核内容"
            align="center"
            show-overflow-tooltip>
            <template>
              <span class="hal-cursor">简历发布</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="时间"
            align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="xiangqing"
            label="简历详情"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="hal-cursor col" @click="toDetail(scope.row.id)">简历详情</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="houxuan"
            label="候选人详情"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="hal-cursor" @click="toDetail2(scope.row.user_id)">候选人详情</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "fabuShen",
    data() {
      return {
        search: '',  // 搜索
        tableData: [],
        multipleSelection: [], //  选中的
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        }
      }
    },
    computed: {
      list() {
        let _list = JSON.parse(JSON.stringify(this.tableData))
        _list.map(item => {
          // 锁定
          console.log(item.create_time)
          item.create_time = this.$tools.ZHDate(new Date(item.create_time * 1000), 1)

        })
        return _list
      },
      user() {
        return this.$store.state.user
      }
    },
    created() {

      this.shenhList()
      this.$emit('setType', 4, 0)
      setInterval(()=>{
        this.shenhList()
      },30000)
    },
    methods: {
      toDetail(id) {
        this.$router.push({
          path: '/home/hxrAdmin/hxrResume',
          query: {
            resumeId: id,
            shenhe:true
          }
        })
      },
      toDetail2(id) {
        this.$router.push({
          path: '/home/hxrAdmin/hxrDetail/' + id
        })
      },
      // 审核列表
      shenhList() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: '',
          spinner: 'a',
          background: 'rgba(255, 255, 255, 0)'
        });
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        this.$api.apiContent.hxrpmShenh({
          search: this.search,
          page: this.page.pageNum,
          pageSize: this.page.pageSize,
          admin_id: this.user.id
        }).then(res => {
           loading.close();
          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          this.tableData = res.data
        }).catch(() => {
           loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })

      },
      handleSizeChange(num) {        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num) {     //  选择页数
        this.page.pageNum = num
      },
      keyWord() {     //  搜索
        if(this.page.pageNum === 1){
          this.setPath()
        }else{
          this.page.pageNum = 1
        }
      },
      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/hxrAdmin/fabuShen',
          query: {
            pageNum: this.page.pageNum,
            key: this.search
          }
        })
      },
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.shenhList()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .content-box {
    .search-box {
      position: absolute;
      top: 10px;
      left: 10px;
      right: 10px;
      z-index: 1;
      display: flex;
      justify-content: flex-end;


      .search {
        width: 220px;
        position: absolute;
        right: 80px;
        border-radius: 4px !important;
      }

      .btn {
        position: absolute;
        left: 0px;
        padding: 10px 40px;
      }
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;


    .page-box {
      position: absolute;
      /*left: 0;*/
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .col {
    color: #1Abc9c;
  }

</style>

